export const QUANTUM_COLS = 12 as const;

export const BREAKPOINTS = ['base', 'sm', 'md', 'lg', 'xl'] as const;
export type Breakpoint = (typeof BREAKPOINTS)[number];

export const PHYSICAL_LIMITS = {
  minSpan: 1,
  maxSpan: QUANTUM_COLS,
  minStart: 1,
  maxStart: QUANTUM_COLS,
  maxRows: 512,
} as const;

/** Default horizontal gap between matrix columns (matches POC gap-x-4 = 16px and form-engine MatrixFieldsMesh). */
export const DEFAULT_MATRIX_COLUMN_GAP_PX = 16;

/** Minimum px per grid track before gear-shifting down (prevents 11-col squeeze in narrow containers). */
export const MIN_TRACK_WIDTH_PX = 80;
